import { api } from "@/shared/api";
import { brandRows } from "@/shared/brand/persona";

// local-only: B (backend schema gap) — /me/modules 返; see proposals/2026-05-17-fe-generated-coverage-misc.md
export type ModuleCard = {
  code: string;
  name: string;
  status: string;
  primaryChannel: string;
  capabilities: string[];
};

// 即将上线模块预告(唯一来源=后端 xb_module_catalog 的 coming_soon 行)。工作台/侧栏/即将上线页共用。
export type ComingSoonModule = {
  capability: string;
  displayName: string;
  description: string | null;
  domain: string;
};

export const dashboardService = {
  listModules: () => api.get<ModuleCard[]>("/me/modules"),
  listComingSoon: () =>
    api
      .get<ComingSoonModule[]>("/me/modules/coming-soon")
      .then((rows) => brandRows(rows, "displayName", "description")),
};
